import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const Refund = () => {
  return (
    <div className="min-h-screen bg-[#fafafd] flex flex-col">
      <Header />
      <main className="flex-1 w-full mx-auto bg-[#fafafd] py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="bg-white p-8 rounded-2xl shadow-md border">
            <h1 className="text-4xl md:text-4xl font-bold text-gray-600 mb-6 text-center">
              Refund Policy
            </h1>
            <p className="text-lg text-gray-600 text-center mb-8">
              Effective Date: December 1, 2024
            </p>

            <section className="mb-8">
              <p className="text-gray-600 mb-4">
                We are committed to providing high-quality AI-based document translation services. This Refund Policy outlines the terms and conditions under which refunds are granted for our pay-per-document services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">1. Acknowledgment of AI-Based Translations</h2>
              <p className="text-gray-600 mb-4">Our service uses advanced AI algorithms to translate documents. While we strive for a high degree of accuracy, AI-based translations may contain errors or inaccuracies. By using our service, you acknowledge and accept that such errors in translation do not constitute a failure of service and are not eligible for a refund.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">2. Eligibility for Refunds</h2>
              <p className="text-gray-600 mb-4">We do not offer refunds for translations that have been delivered and are free of major errors. Refund requests will be considered on a case-by-case basis under the following circumstances:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Major Errors:</span> If the translation contains significant errors that render it unusable for its intended purpose, you may be eligible for a partial or full refund. The determination of what constitutes a &quot;major error&quot; is at the sole discretion of Paralegal (Pvt) Ltd.</li>
                <li><span className="font-semibold">Service Failure:</span> If we fail to deliver the translation within the promised timeframe due to a fault of our own, you may be eligible for a full refund.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">3. Non-Refundable Cases</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Minor inaccuracies or stylistic differences in the translation.</li>
                <li>Delays caused by circumstances outside of our control, such as incorrect file formats or issues with the source document.</li>
                <li>Change of mind after the translation has been completed and delivered.</li>
                <li>Violations of our Terms of Service.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">4. Refund Process</h2>
              <p className="text-gray-600 mb-4">To request a refund, follow these steps:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Contact our support team at <a href="mailto:admin@paralegal.lk" className="text-pl_prim_color_1 underline">admin@paralegal.lk</a> with your order details, the source document, the translated document, and a detailed explanation of the issue.</li>
                <li>Our team will review your request and may ask for additional information. We aim to respond within 7 business days.</li>
                <li>Approved refunds will be processed within 14 business days to the original payment method.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">5. Dispute Resolution</h2>
              <p className="text-gray-600 mb-4">If you are not satisfied with our decision regarding a refund, you may request a further review by contacting our management team at <a href="mailto:management@paralegal.lk" className="text-pl_prim_color_1 underline">admin@paralegal.lk</a>. The decision of the management team will be final.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">6. Changes to the Refund Policy</h2>
              <p className="text-gray-600 mb-4">We reserve the right to modify this Refund Policy at any time. Changes will be posted on our website, and continued use of our services after such changes indicates acceptance of the updated policy.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Contact Us</h2>
              <p className="text-gray-600 mb-4">For any questions regarding this Refund Policy, please contact us at <a href="mailto:admin@paralegal.lk" className="text-pl_prim_color_1 underline">admin@paralegal.lk</a>.</p>
              <p className="text-gray-600">
                Paralegal (Pvt) Ltd<br />
                95, Chemmani Road,<br />
                Nallur,<br />
                Jaffna 40000
              </p>
              <p className="text-gray-600">
                email: <a href="mailto:admin@paralegal.lk" className="text-pl_prim_color_1 underline">admin@paralegal.lk</a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Refund;
